import ChangeOfOwnershipCertificate from "../components/CowCertificate";

export default function CowCertificate(){
    return(
        <>
            <ChangeOfOwnershipCertificate />
        </>
    )
}